import { useEffect } from 'react';
import TagManager from 'react-gtm-module';

const GoogleTagManager = TagManager;

const dataLayerOriginal = TagManager.dataLayer;

GoogleTagManager.dataLayer = (dataLayer, dataLayerName) => {
  dataLayerOriginal({
    dataLayer,
    dataLayerName,
  });
};

/**
 * Sends an `analytic_event` event to GTM dataLayer with the eventName `event`
 * and with optional parameter `id`
 *
 * @param event {string}
 * @param id {(string|undefined)}
 * @return {*}
 */
GoogleTagManager.sendEvent = (event, id = undefined) =>
  GoogleTagManager.dataLayer({
    event: 'analytic_event',
    eventName: event,
    id,
  });

export const LOOTPACK_PATH = '/loot';
export const LOOTPACK_PURCHASE_PATH = '/loot/purchase';

export const useGoogleTagManagerPage = (pageName) => {
  useEffect(() => {
    GoogleTagManager.dataLayer({
      event: 'PageView',
      pageName,
    });
  }, [pageName]);
};

export const recordOpenScreenEvent = (screen, params = {}) => {
  GoogleTagManager.dataLayer({
    event: 'open_screen',
    screen,
    ...params,
  });
};

export const useOpenScreenEvent = (screen, params = {}, deps = []) => {
  useEffect(() => {
    recordOpenScreenEvent(screen, params);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
};

export default GoogleTagManager;
